import React from "react";
import { formatTime, getFormattedDateString } from "utility/helpers";
import { ATTENDANCE_STATUS_OPTIONS } from "constants/status";
import styled from "styled-components";
import CustomSelect from "components/customs/dropdown";
import { statusSelectStyles } from "constants/style";
import { CellText } from "assets/js/Styles";

const StyledDropdown = styled(CustomSelect)`
  width: 100%;

  .select__control:has(.did-not-attend-status) {
    background-color: #e1700d;
    border: none;
    .did-not-attend-status {
      color: white;
    }
  }

  .select__control:has(.invited-status) {
    background-color: #00316d;
    border: none;
    .invited-status {
      color: white;
    }
  }

  .select__control:has(.confirmed-status) {
    background-color: #53a24c;
    border: none;
    .confirmed-status {
      color: white;
    }
  }

  .select__control:has(.declined-status) {
    background-color: #df3348;
    border: none;
    .declined-status {
      color: white;
    }
  }

  .select__control:has(.no-response-status) {
    background-color: #ffbd14;
    border: none;
    .no-response-status {
      color: white;
    }
  }

  .select__control:has(.attended-status) {
    background-color: #265ea3;
    border: none;
    .attended-status {
      color: white;
    }
  }
`;

const eventCongressmanColumns = ({ handleStatusChange }) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "Event Name",
      selector: (eventName) => eventName,
      identifier: "eventName",
      grow: 3,
      sortable: true,
      cell: ({ eventName }) => <CellText>{eventName}</CellText>,
    },
    {
      name: "Date Period",
      selector: (Event) => Event,
      identifier: "eventStartDate",
      grow: 2,
      sortable: true,
      cell: ({ eventStartDate, eventEndDate }) => (
        <CellText>
          {getFormattedDateString(eventStartDate, "MMM dd, yyyy")}
          {" - "}
          {getFormattedDateString(eventEndDate, "MMM dd, yyyy")}
        </CellText>
      ),
    },
    {
      name: "Time",
      selector: (Event) => Event,
      identifier: "eventStartTime",
      grow: 2,
      sortable: true,
      cell: ({ eventStartTime, eventEndTime }) => (
        <CellText>
          {formatTime(eventStartTime)}
          {" - "}
          {formatTime(eventEndTime)}
        </CellText>
      ),
    },
    {
      name: "Venue",
      selector: (eventVenue) => eventVenue,
      identifier: "eventVenue",
      grow: 2,
      sortable: true,
      cell: ({ eventVenue }) => <CellText>{eventVenue}</CellText>,
    },
    {
      name: "Status",
      selector: (status) => status,
      identifier: "EventParticipants.eventParticipantStatus",
      width: "180px",
      sortable: true,
      cell: ({ EventParticipants }, index) => {
        return (
          <StyledDropdown
            isSearchable={false}
            getOptionLabel={(option) => {
              return option?.displayLabel;
            }}
            menuPortalTarget={document.body}
            styles={statusSelectStyles}
            options={ATTENDANCE_STATUS_OPTIONS}
            onChange={(option) => {
              handleStatusChange(index, option);
            }}
            value={ATTENDANCE_STATUS_OPTIONS.find(
              (stat) =>
                stat?.value === EventParticipants[0].eventParticipantStatus
            )}
          />
        );
      },
    },
  ];
};

export default eventCongressmanColumns;
